import store from '../../../store';
import { SIGN_USER_OUT, REFRESH_TOKENS, authStore } from '../store';
import { tokenStorage } from '../../../shared/storage-service';
import { APP_DATA } from '../../../app.config';

let signoutPingResponsSubscriber = null; // todo: move this to store and make it non global

export default {
  name: 'AuthHelper',
  signUserOut: async () => store.dispatch(SIGN_USER_OUT),
  signUserInSystemaAutomatically: async () => {
    window.location.replace(window.location.origin);
  },
  refreshTokensIfNotRequestedAlready: async () => {
    const refreshToken = tokenStorage.getRefreshToken();
    if (!refreshToken) throw new Error('REFRESH_TOKEN is Empty');

    const now = new Date().getTime();
    let refreshNeeded = false;

    const refreshReqTimeStr = tokenStorage.getRefreshReqData();
    // --- get last refresh requested time, if null make the request ----//
    const refreshHasNotRequested = !refreshReqTimeStr || Number.isNaN(refreshReqTimeStr);
    if (refreshHasNotRequested) refreshNeeded = true;
    else {
      // --- if it has been more than 5 secs since last made the request, make the request --//
      const lastRefreshRequestedTime = parseInt(refreshReqTimeStr, 10);

      // ---- 2 seconds: max estimated delay allowed for the first request complete ---//
      const isLastRequestTooOld = ((now - lastRefreshRequestedTime) / 1000 > 2);

      if (isLastRequestTooOld) refreshNeeded = true;
      // ---- else: refresh request has been made already within 2 seconds
    }

    if (refreshNeeded) { // ----- Refresh the tokens ---- //
      tokenStorage.setRefreshReqData(now);
      store.dispatch(REFRESH_TOKENS, refreshToken);
    }
  },
  broadcastSignoutPing: (callback) => {
    const now = new Date().getTime();
    signoutPingResponsSubscriber = callback;
    const signoutBroadcastData = `PING.${APP_DATA.appKey}.${now}`;
    tokenStorage.setSignOutBroadcastData(signoutBroadcastData);
  },
  broadcastSignoutPingResponse: (sourceAppKey) => {
    const { loggedUser } = authStore.state;
    if (loggedUser) {
      const now = new Date().getTime();
      const signoutBroadcastData = `RESP.${sourceAppKey}.${now}`;
      tokenStorage.setSignOutBroadcastData(signoutBroadcastData);
    }
  },
  signoutPingResponseHandler: (e) => {
    if (signoutPingResponsSubscriber !== null) {
      signoutPingResponsSubscriber(e);
      signoutPingResponsSubscriber = null;
    }
  },
};
